import React from 'react';
import { Form, Formik } from 'formik';
import { useTranslation } from '../../../../../../i18n/use-translation';
import { Button } from '../../../../../atoms/button';
import { Size } from '../../../../../enums/size';
import { Input } from '../../../../../molecules/Input';
import * as styles from './restore-password.module.sass';
import { getDefaultSignParams } from './res/default_params';
import { getResetPasswordValidation } from './res/schema';
import { ResetPasswordFormProps } from './type/props';
import { SmallPreloader } from '../../../../../atoms/preloaders/smal_preloader';

export const ResetPasswordForm = (props: ResetPasswordFormProps) => {
  const { t } = useTranslation();

  return (
    <>
      <h3 className={styles.recover_head}>{t('recover_pass')}</h3>
      <div className={styles.recover_description}>{t('recover_description')}</div>
      <Formik
        initialValues={{ ...getDefaultSignParams() }}
        validationSchema={getResetPasswordValidation()}
        onSubmit={props.onPasswordReset}
      >
        <Form>
          <Input name="phone" label={t('phone')} required mask="+380999999999" />

          {props.isLoading ? (
            <SmallPreloader />
          ) : (
            <Button type="submit" text={t('recover_pass')} size={Size.BIG} className={styles.modal_button} />
          )}
        </Form>
      </Formik>
    </>
  );
};
